import React, { useState } from "react";
import { FaFilter, FaSearch, FaCalendarAlt, FaChevronDown, FaChevronUp, FaUserSecret, FaStar } from "react-icons/fa";

const ClientFilters = ({
  searchQuery,
  setSearchQuery,
  employeeFilter,
  setEmployeeFilter,
  employees,
  stepFilter,
  setStepFilter,
  paymentFilter,
  setPaymentFilter,
  serviceFilter,
  setServiceFilter,
  taxYearStart,
  setTaxYearStart,
  taxYearEnd,
  setTaxYearEnd,
  dueDateStart,
  setDueDateStart,
  dueDateEnd,
  setDueDateEnd,
  selectionMode,
  setSelectionMode,
  ratingFilter,
  setRatingFilter,
}) => {

  const [showAdvanced, setShowAdvanced] = useState(false);

  return (
    <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-card p-4 mb-4">
      <div className="flex flex-col lg:flex-row gap-4 items-end">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 flex-grow w-full">
          {/* Search */}
          <div className="space-y-2">
            <label className="flex items-center gap-2 text-xs font-semibold text-gray-700 dark:text-gray-300">
              <FaSearch className="w-3.5 h-3.5 text-primary-500" /> Search Clients
            </label>
            <input
              type="text"
              placeholder="Search by name or email"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full px-4 py-1.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500 transition-all"
            />
          </div>

          {/* Employee Filter */}
          <div className="space-y-2">
            <label className="flex items-center gap-2 text-xs font-semibold text-gray-700 dark:text-gray-300">
              <FaFilter className="w-3.5 h-3.5 text-primary-500" /> Filter by Employee
            </label>
            <select
              value={employeeFilter}
              onChange={(e) => setEmployeeFilter(e.target.value)}
              className="w-full px-4 py-1.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500 transition-all cursor-pointer"
            >
              <option value="all">All Employees</option>
              {employees.map((employee) => (
                <option key={employee._id} value={employee._id}>
                  {employee.name}
                </option>
              ))}
            </select>
          </div>

          {/* Step Filter */}
          <div className="space-y-2">
            <label className="flex items-center gap-2 text-xs font-semibold text-gray-700 dark:text-gray-300">
              <FaFilter className="w-3.5 h-3.5 text-primary-500" /> Filter by Step
            </label>
            <select
              value={stepFilter}
              onChange={(e) => setStepFilter(e.target.value)}
              className="w-full px-4 py-1.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500 transition-all cursor-pointer"
            >
              <option value="all">All Steps</option>
              
              {/* Total Status Options */}
              <optgroup label="Total Status">
                <option value="total-in-progress">Total In-Progress</option>
                <option value="total-completed">Total Completed</option>
                <option value="total-pending">Total Pending</option>
              </optgroup>
              
              {/* Step 1 Status */}
              <optgroup label="Step 1 Status">
                <option value="step1-in-progress">Step 1 In-Progress</option>
                <option value="step1-completed">Step 1 Completed</option>
                <option value="step1-pending">Step 1 Pending</option>
              </optgroup>
              
              {/* Step 2 Status */}
              <optgroup label="Step 2 Status">
                <option value="step2-in-progress">Step 2 In-Progress</option>
                <option value="step2-completed">Step 2 Completed</option>
                <option value="step2-pending">Step 2 Pending</option>
              </optgroup>
              
              {/* Step 3 Status */}
              <optgroup label="Step 3 Status">
                <option value="step3-in-progress">Step 3 In-Progress</option>
                <option value="step3-completed">Step 3 Completed</option>
                <option value="step3-pending">Step 3 Pending</option>
              </optgroup>
              
              {/* Step 4 Status */}
              <optgroup label="Step 4 Status">
                <option value="step4-in-progress">Step 4 In-Progress</option>
                <option value="step4-completed">Step 4 Completed</option>
                <option value="step4-pending">Step 4 Pending</option>
              </optgroup>
            </select>
          </div>

          {/* Payment Filter */}
          <div className="space-y-2">
            <label className="flex items-center gap-2 text-xs font-semibold text-gray-700 dark:text-gray-300">
              <FaFilter className="w-3.5 h-3.5 text-primary-500" /> Payment Status
            </label>
            <select
              value={paymentFilter}
              onChange={(e) => setPaymentFilter(e.target.value)}
              className="w-full px-4 py-1.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500 transition-all cursor-pointer"
            >
              <option value="all">All</option>
              <option value="paid">Paid</option>
              <option value="unpaid">Unpaid</option>
              <option value="wip-unpaid">WIP–Unpaid</option>
              <option value="p-extension">P Extension</option>
              <option value="up-extension">UP Extension</option>
            </select>
          </div>

          {/* Service Filter */}
          <div className="space-y-2">
            <label className="flex items-center gap-2 text-xs font-semibold text-gray-700 dark:text-gray-300">
              <FaFilter className="w-3.5 h-3.5 text-primary-500" /> Services
            </label>
            <select
              value={serviceFilter}
              onChange={(e) => setServiceFilter(e.target.value)}
              className="w-full px-4 py-1.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500 transition-all cursor-pointer"
            >
              <option value="all">All Services</option>
              <option value="usa">USA Company</option>
              <option value="tax">Tax Filing</option>
              <option value="bookkeeping">Bookkeeping</option>
              <option value="cfo">CFO Advisory</option>
              <option value="registeredAgent">Registered Agent</option>
            </select>
          </div>

          {/* Rating Filter */}
          <div className="space-y-2">
            <label className="flex items-center gap-2 text-xs font-semibold text-gray-700 dark:text-gray-300">
              <FaStar className="w-3.5 h-3.5 text-yellow-500" /> Feedback Rating
            </label>
            <select
              value={ratingFilter}
              onChange={(e) => setRatingFilter(e.target.value)}
              className="w-full px-4 py-1.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500 transition-all cursor-pointer"
            >
              <option value="all">All Ratings</option>
              <option value="5">5 Stars</option>
              <option value="4">4 Stars</option>
              <option value="3">3 Stars</option>
              <option value="2">2 Stars</option>
              <option value="1">1 Star</option>
              <option value="none">No Rating</option>
            </select>
          </div>
        </div>

        <button
          onClick={() => setShowAdvanced(!showAdvanced)}
          className="lg:mb-0.5 flex items-center justify-center gap-2 px-3 py-1.5 text-xs font-semibold text-primary-600 bg-primary-50 dark:bg-primary-900/20 rounded-lg hover:bg-primary-100 dark:hover:bg-primary-900/30 transition-all whitespace-nowrap"
        >
          {showAdvanced ? <FaChevronUp className="w-3 h-3" /> : <FaChevronDown className="w-3 h-3" />}
          {showAdvanced ? "Hide Date Filters" : "Date Filters"}
        </button>

        <button
          onClick={() => setSelectionMode(!selectionMode)}
          className={`lg:mb-0.5 flex items-center justify-center gap-2 px-3 py-1.5 text-xs font-semibold rounded-lg transition-all whitespace-nowrap ${
            selectionMode 
              ? "bg-primary-600 text-white hover:bg-primary-700 shadow-md shadow-primary-500/30" 
              : "text-gray-600 bg-gray-100 dark:bg-dark-700 hover:bg-gray-200 dark:hover:bg-dark-600"
          }`}
        >
          <FaUserSecret className={`w-3 h-3 ${selectionMode ? "animate-pulse" : ""}`} />
          {selectionMode ? "Selection Active" : "Selection Mode"}
        </button>
      </div>


      {showAdvanced && (
        <div className="mt-4 pt-4 border-t border-gray-100 dark:border-dark-700 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 animate-in fade-in slide-in-from-top-2 duration-300">
          <div className="space-y-2">
            <label className="flex items-center gap-2 text-xs font-semibold text-gray-700 dark:text-gray-300">
              <FaCalendarAlt className="w-3.5 h-3.5 text-primary-500" /> Tax Year End (From)
            </label>
            <input
              type="date"
              value={taxYearStart}
              onChange={(e) => setTaxYearStart(e.target.value)}
              className="w-full px-4 py-1.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500"
            />
          </div>

          <div className="space-y-2">
            <label className="flex items-center gap-2 text-xs font-semibold text-gray-700 dark:text-gray-300">
              <FaCalendarAlt className="w-3.5 h-3.5 text-primary-500" /> Tax Year End (To)
            </label>
            <input
              type="date"
              value={taxYearEnd}
              onChange={(e) => setTaxYearEnd(e.target.value)}
              className="w-full px-4 py-1.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500"
            />
          </div>

          <div className="space-y-2">
            <label className="flex items-center gap-2 text-xs font-semibold text-gray-700 dark:text-gray-300">
              <FaCalendarAlt className="w-3.5 h-3.5 text-primary-500" /> Due Date (From)
            </label>
            <input
              type="date"
              value={dueDateStart}
              onChange={(e) => setDueDateStart(e.target.value)}
              className="w-full px-4 py-1.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500"
            />
          </div>

          <div className="space-y-2">
            <label className="flex items-center gap-2 text-xs font-semibold text-gray-700 dark:text-gray-300">
              <FaCalendarAlt className="w-3.5 h-3.5 text-primary-500" /> Due Date (To)
            </label>
            <input
              type="date"
              value={dueDateEnd}
              onChange={(e) => setDueDateEnd(e.target.value)}
              className="w-full px-4 py-1.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientFilters;